module.exports = __webpack_public_path__ + "static/media/poland.04e334ac.svg";